import {axiosInstance} from '../helpers'


const url = '/survey-link'

const get = params => axiosInstance.get({url: `${url}?${params}`})

export const surveyLinkServices = {
  get,
}